<template>
  <header>
    <a class="logo-link" href="/" @click.prevent="navigate('index', null)">
      <img src="~assets/logo-ateljens-pizza-enskede.svg?file" alt="Ateljéns Pizza" class="main-logo" />
    </a>

    <div class="welcome-content">
      <h1>Välkommen till <br />Ateljéns Pizza i Enskede</h1>
    </div>

    <nav>
      <ul>
        <li class="nav-item-container" v-for="(link, index) in document.links" :key="index">
          <a :class="['nav-item', link.type]" :href="urlFor(link)" @click.prevent="navItemClick(link)">
            {{ link.title }}
          </a>
        </li>
      </ul>

    </nav>
  </header>
</template>

<script>
import SliceLoader from 'mixins/slice-loader';
import Navigation from 'mixins/navigation';

export default {
  name: 'Header',
  mixins: [SliceLoader, Navigation],
  data() {
    return {
      contentParams: { type: 'navigation', uid: '*', location: 'enskede' }
    };
  },

  methods: {
    navItemClick(link) {
      this.actionFor(link);
    },

    navigate(route, uid) {
      const { currentRoute } = this.$router;
      const location = this.$route.params.location || this.$route?.meta?.location;

      // Determine the actual route name that will be used
      let targetRouteName = route;
      if (uid === 'takeaway') {
        targetRouteName = 'takeaway';
      }

      const isSameRoute = currentRoute.name === targetRouteName;
      const isSameLocation = currentRoute.params.location === location;
      const isUidMatch = currentRoute.params.uid === uid;
      const isIndexRoute = route === 'index';

      // Don't navigate if we're already on the target page
      if (isSameRoute && isSameLocation && (isUidMatch || isIndexRoute || uid === 'takeaway')) {
        return;
      }

      // Don't pass location param when navigating to index
      const params = isIndexRoute ? {} : { uid, location };
      const routerParams = { name: targetRouteName, params };

      this.$router.push(routerParams);
    }
  }
};
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/helpers'
  @require '~global/breakpoints'
  @require '~global/typo'

  header
    display: flex
    flex-direction: column
    align-items: center
    width: 100%
    padding: 4rem $default-padding-mobile 0 $default-padding-mobile

  .logo
    width: 100%
    max-width: 700px

  .logo-link
    width: 100%
    line-height: 0
    margin-bottom: 3rem
    text-align: center
    img
      width: 100%
      max-width: 900px

  .welcome-content
    display: flex
    flex-direction: column
    gap: 0.25rem
    text-align: center
    margin-bottom: .9rem

  h1
    margin-bottom: 2rem
    text-transform: uppercase
    line-height: 1.3rem

  p
    margin: 0.125rem 0
    text-transform: uppercase

  nav
    width: 100%
    max-width: 600px
    text-align: center

  .nav-item-container
    margin-bottom: 1.4rem

  .nav-item
    @extend .t-subHeader
    border-bottom: 1px solid


  @media (max-width: $mobile)
    .nav-item
      font-size: .9rem
      margin: 0 .3rem

</style>
